import request from "../utils/request";

export async function getMoodfelekExpireDay() {
  return request.get("AppSettings/MoodfelekExpireDays")
}

export async function setMoodfelekExpireDay(payload) {
  if (payload && payload.day) {
    payload.day = parseInt(payload.day)
  }
  return request.put("AppSettings/MoodfelekExpireDays", payload);
}

export async function getMoodCost() {
  return request.get("AppSettings/GetMoodCost")
}

export async function getPosSettings(branchId) {
  return request.get("AppSettings/pos?branchId=" + branchId);
}
export async function setPosSettings(payload) {
  return request.post("AppSettings/pos",payload)
}

export async function setSubPosSettings(payload) {
  return request.post("AppSettings/sub-pos",payload)
}

export async function getMoodGiftCost() {
  return request.get("AppSettings/GetMoodGiftCost")
}

export async function setMoodCost(payload) {
  payload.cost = parseFloat(payload.cost)
  return request.put("AppSettings/SetMoodCost", payload)
}

export async function setMoodGiftCost(payload) {
  payload.cost = parseFloat(payload.cost)
  return request.put("AppSettings/SetMoodGiftCost", payload)
}

export async function getPrivateCampaignExpireDay() {
  return request.get("AppSettings/PrivateCampaignExpireDays")
}

export async function setPrivateCampaignExpireDay(payload) {
  if (payload && payload.day) {
    payload.day = parseInt(payload.day)
  }
  return request.put("AppSettings/PrivateCampaignExpireDays", payload);
}

export async function getMoodfelekPeriod() {
  return request.get("AppSettings/GetMoodfelekPeriod")
}

export async function setMoodfelekPeriod(payload) {
  if (payload && payload.dayPeriod) {
    payload.dayPeriod = parseInt(payload.dayPeriod)
  }
  return request.post("AppSettings/SetMoodfelekPeriod", payload);
}

export async function setNavigationQuestion(payload) {
  return request.post("AppSettings/NavigationQuestion", payload);
}

export async function getNavigationQuestion() {
  return request.get("AppSettings/NavigationQuestion")
}

export async function getAllPosSettings() {
  return request.get("AppSettings/allpos");
}

export async function setPosStatus(branchId, enabled) {
  return request.get("AppSettings/set-pos-status?branchId="+branchId + "&enabled=" + enabled);
}

export async function navigationQuestionForRedirect() {

  return new Promise((resolve, reject) => {

    request.get("AppSettings/NavigationQuestionForRedirect").then(response => {
      if (response.status != 200) {
        reject(new Error(response.data.message));
      }
      resolve(response.data);
    }).catch(e => {
      reject(e);
    });

  });

}
